import React from 'react';

function SignupThankyou() {
  return (
    <div>
      Thankyou for creating an account! Please check your email to verify your
      account.
    </div>
  );
}

export default SignupThankyou;
